'use client';
import styled from 'styled-components';

const TourContent = styled.div`
  margin-top: 20px;

  a {
    color: ${(props) => props.theme.palette.primaryBrand};
  }
`;

export default TourContent;
